





















































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { playback } from '@/service/embedPlayer.service'
import './style.less'

@Component
export default class Player extends Vue {
  @Prop(Number) grid!: number
  @Prop(String) src!: string
  @Prop(Boolean) debug!: boolean
  @Prop(Boolean) muted!: boolean
  @Prop(Boolean) controls!: boolean
  @Prop(Boolean) autoplay!: boolean

  // __DATA
  private played: boolean = false
  private embed: any = {}
  private ctrl: any = {
    ready: false,
    play: false,
    load: this.autoplay,
    muted: this.muted,
    currentTime: Number(this.live)
  }
  private clientWidth = 0

  // __MOUNTED
  public mounted (): void {
    this.$nextTick(() => {
      this.clientWidth = this.$el.clientWidth
      if (this.autoplay) this.connectToPlayer(true)
    })
  }

  // __METHODS
  private connectToPlayer (autoplay: boolean): void {
    const id: any = this.$vnode.key as string
    this.embed = playback(id, {
      log: this.debug,
      src: this.src,
      muted: this.muted,
      autoplay: autoplay || this.autoplay,
      callback: (res: any) => this.callback(res)
    })
  }

  private callback (param: any): void {
    if (param.status === 'playing') {
      this.played = true
    }
    else if (param.status === 'ready') {
      this.ctrl.ready = true
    }

    this.ctrl.play = (param.status === 'playing')
    this.ctrl.load = (param.status === 'connecting')
  }

  private onPlay (): void {
    if (!this.autoplay && !this.embed.x) {
      this.ctrl.load = true
      this.ctrl.ready = true
      this.connectToPlayer(true)
    }
    else if (this.ctrl.ready) {
      if (this.ctrl.play) {
        this.embed.pause()
        this.ctrl.play = false
      } else {
        this.embed.play()
        this.ctrl.play = true
      }
    }
  }

  private onMuted (): void {
    this.ctrl.muted = !this.ctrl.muted
    this.embed.muted(this.ctrl.muted)
  }

  private onExpand (): void {
    const element: any = this.$el.querySelector('embed')
    if (element.requestFullscreen) {
      element.requestFullscreen()
    }
    else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen()
    }
    else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen()
    }
    else if (element.msRequestFullscreen) {
      element.msRequestFullscreen()
    }
  }

  // __ COMPUTED
  private get live (): boolean {
    return Boolean(this.src.match('rtsp://'))
  }

  private get useControls (): boolean {
    return this.controls && this.clientWidth > 320
  }

  // __WATCH
  @Watch ('grid')
  private inSize () {
    this.clientWidth = this.$el.clientWidth
  }
}
